const routeMovieDetail = (id: string = ':id'): string => `/movies/${id}`;

export default routeMovieDetail;
